__turbopack_context__.v({
  "app_light_theme": "tabs-module-scss-module__23YSQq__app_light_theme",
  "tab": "tabs-module-scss-module__23YSQq__tab",
  "tab--active": "tabs-module-scss-module__23YSQq__tab--active",
  "tab--disabled": "tabs-module-scss-module__23YSQq__tab--disabled",
  "tab--large": "tabs-module-scss-module__23YSQq__tab--large",
  "tab--small": "tabs-module-scss-module__23YSQq__tab--small",
  "tab-pane": "tabs-module-scss-module__23YSQq__tab-pane",
  "tab-pane--hidden": "tabs-module-scss-module__23YSQq__tab-pane--hidden",
  "tab_accent_line": "tabs-module-scss-module__23YSQq__tab_accent_line",
  "tabs": "tabs-module-scss-module__23YSQq__tabs",
  "tabs--bottom": "tabs-module-scss-module__23YSQq__tabs--bottom",
  "tabs--left": "tabs-module-scss-module__23YSQq__tabs--left",
  "tabs--right": "tabs-module-scss-module__23YSQq__tabs--right",
  "tabsNav": "tabs-module-scss-module__23YSQq__tabsNav",
  "tabsNavWrapper": "tabs-module-scss-module__23YSQq__tabsNavWrapper",
  "tabsNav__list": "tabs-module-scss-module__23YSQq__tabsNav__list",
  "tabsNav__stuck": "tabs-module-scss-module__23YSQq__tabsNav__stuck",
  "tabs__content": "tabs-module-scss-module__23YSQq__tabs__content",
  "tabs__nav": "tabs-module-scss-module__23YSQq__tabs__nav",
  "tabs__nav--centered": "tabs-module-scss-module__23YSQq__tabs__nav--centered",
});
